import React, { useState, useEffect } from 'react';
import { Snackbar, Alert } from '@mui/material';
import NotificationService from 'app/services/NotificationService';
import { Typography } from '@material-ui/core';

const NotificationProvider = () => {
	const [open, setOpen] = useState(false);
	const [message, setMessage] = useState('');
	const [severity, setSeverity] = useState('info');

	const handleClose = () => {
		setOpen(false);
	};

	useEffect(() => {
		NotificationService.register((msg, sev) => {
			setMessage(msg);
			setSeverity(sev || 'info');
			setOpen(true);
		});
	}, []);

	return (
		<Snackbar
			open={open}
			autoHideDuration={6000}
			onClose={handleClose}
			anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
		>
			<Alert onClose={handleClose} severity={severity} variant="filled" className="w-[var(--width)]">
				<Typography variant="h5">
					<strong>{message}</strong>
				</Typography>
			</Alert>
		</Snackbar>
	);
};

export default NotificationProvider;
